import React, { ReactNode, Suspense } from 'react'
import { Box, CircularProgress } from '@mui/material'
import HeaderMenu from './HeaderMenu'

export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',
}

interface Props {
  children: ReactNode
}

const PageContentFallback = () => (
  <Box
    sx={{
      flex: 1,
      minHeight: 160,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={28} thickness={4} />
  </Box>
)

/** Layout full viewport — header giữ nguyên khi đổi route (Suspense chỉ quanh content). */
const BasicLayout: React.FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        height: '100vh',
        minHeight: '-webkit-fill-available',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <HeaderMenu />
      <Box
        component="main"
        className="site-layout-background basic-layout-content"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          /* Trang không scroll — list/form tự quản lý vùng cuộn bên trong */
          overflow: 'hidden',
          boxSizing: 'border-box',
          px: 2,
          pt: 1,
          pb: 1.5,
          bgcolor: 'background.paper',
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          <Suspense fallback={<PageContentFallback />}>{children}</Suspense>
        </Box>
      </Box>
    </Box>
  )
}

export default BasicLayout
